import notify from '@/api/notification'

const MAX_FILE_SIZE = 50000000 // 50 MB
const VALID_FILE_TYPES = ['image/', 'application/pdf']

const uploadFileUtils = {
  validateFileType(file) {
    if (!this.isValidFileType(file)) {
      notify({
        title: 'ERRO: Arquivo inválido!',
        message: 'Selecione uma imagem ou PDF para anexo.'
      })
      return false
    }

    if (!this.isValidFileSize(file)) {
      notify({
        title: 'AVISO:',
        message: 'Limite de 50 MB por arquivo.'
      })
      return false
    }

    return true
  },

  isValidFileType(file) {
    return VALID_FILE_TYPES.some(type => file.type.startsWith(type))
  },

  isValidFileSize(file) {
    return file.size <= MAX_FILE_SIZE
  }
}

export default uploadFileUtils
